import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import validator from "components/Shared/MGridFormDefinitions/validator";
import MGridForm from "components/Shared/MGridForm";
import { DATA_TYPE_STRING, DATA_TYPE_MULTI_LINE_STRING } from "typeConstants/dataTypes";
import { MSpinner } from "components/Shared";
import { sendMessage } from "requests/appraisalPort";

const emptyMessageRequest = {
  subject: "",
  message: ""
};

const Message = ({ controlNumber, onSuccessCallback }) => {
  const [messageRequest, setMessageRequest] = useState(emptyMessageRequest);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const controlMethods = useRef({});
  const mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  if (isSubmitting) {
    return <MSpinner />;
  }

  const formDefinition = [
    [{ dataType: DATA_TYPE_STRING, label: "Subject:", source: "subject", hasValidationError: validator.required }],
    [{ dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Message:", source: "message", hasValidationError: validator.required }]
  ];

  const isValid = () => {
    if (typeof controlMethods?.current?.isFormValid === "function") {
      return controlMethods.current.isFormValid();
    }
    return false;
  };

  const handleOnChange = (updatedObject) => setMessageRequest({ ...updatedObject });

  const handleSend = () => {
    if (isValid()) {
      setIsSubmitting(true);
      sendMessage(controlNumber, messageRequest.subject, messageRequest.message, onSuccess, onError, mounted);
    }
  };

  const onSuccess = () => {
    if (onSuccessCallback) onSuccessCallback();
  };

  const onError = () => {
    setIsSubmitting(false);
  };

  return (
    <div>
      <MGridForm
        key="appraisal-port-message-form"
        data={messageRequest}
        onChange={handleOnChange}
        formDefinition={formDefinition}
        getControlMethods={cm => { controlMethods.current = cm; }}
        webform={true}
      />
      <Button
        key="message-send-button"
        onClick={handleSend}
        disabled={!isValid()}
      >
        Send
      </Button>
    </div>
  );
};

Message.propTypes = {
  controlNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onSuccessCallback: PropTypes.func,  // Function to call after successfully updating on hold status
};

const mapStateToProps = (state) => {
  return {
    controlNumber: state.caseDetails.controlNumber,
  };
};

export default connect(mapStateToProps)(Message);